import * as React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Colors, Fonts } from '../utils/Constants';

export default class CallScript extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
        hovering: false,
        clicked: false,
    }
  }

  clickedButton = () => {
      this.setState({
        clicked: !this.state.clicked
      })
  }

  hoverButton = () => {
    if(this.state.clicked == false){
      this.setState({
        hovering: !this.state.hovering
      })
    }
  }
  render(){

    let colors = {
      defaultBgColor: this.props.defaultBgColor ? this.props.defaultBgColor : 'white',
      highlightedBgColor: this.props.highlightedBgColor ? this.props.highlightedBgColor : '#33789B',
      defaultTextColor: this.props.defaultTextColor ? this.props.defaultTextColor : Colors.cobalt,
      greyTextColor: "#BDBDBD",
      highlightedTextColor: this.props.highlightedTextColor ? this.props.highlightedTextColor : 'white'
    }

    var properties = {
      phone: require('../assets/images/unhoverphone.svg'),
      arrow: require('../assets/images/scriptarrow.svg'),
      color: colors.defaultBgColor,
      textColor: colors.defaultTextColor
    };

    if(this.state.clicked){
      properties = {
        color: colors.defaultBgColor,
        textColor: colors.greyTextColor,
        arrow: require('../assets/images/scriptarrow.svg'),
      }
    }
    else{
        properties = {
        color: colors.defaultBgColor,
        textColor: colors.defaultTextColor,
        arrow: require('../assets/images/scriptarrow.svg'),
        }

    }


    return (
      <View style={[styles.script, {width: this.props.width, backgroundColor: properties.color}]}>
        <TouchableOpacity style={{width: '100%', marginBottom: this.state.clicked ? 10:0}} onPress={() => this.clickedButton()}>
          <View style = {[styles.button, {height: '100%', borderRadius: this.props.border, backgroundColor: properties.color}]}>
            <View style={{flex: 16, alignItems: 'center'}}>
                <Text style={[styles.contactname, {color: properties.textColor}]}>{this.state.clicked ? "Close Script" : "View Script"}</Text>
            </View>
            <Image
                style={{width: 34, height: 34, marginRight: 30, resizeMode: 'contain', transform: [{ rotate: this.state.clicked ? '180deg' : '0deg' }]}}
                source={properties.arrow}
            />
          </View>
        </TouchableOpacity>
        {this.state.clicked &&
        <View style={{padding: 20, width: '100%'}}>
          <Text style={{fontFamily: Fonts.mainFont, fontSize: 17, fontWeight: 'normal'}}>
              {this.props.text}
          </Text>
        </View>
        }
      </View>
    );
  }
}

CallScript.navigationOptions = {
  header: null,
};

const styles = StyleSheet.create({
  button: {
    padding: 5,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // marginBottom: 10,
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 2.54,
    // },
    // shadowOpacity: 0.1,
    // shadowRadius: 15,
  },
  script: {
    padding: 10,
    alignItems: 'center',
    // flexDirection: 'row',
    // justifyContent: 'space-between',
    marginBottom: 20,
    borderWidth: 1,
    borderColor: Colors.cobalt
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 2.54,
    // },
    // shadowOpacity: 0.1,
    // shadowRadius: 8,
  },
  contactname: {
    fontFamily: Fonts.mainFont,
    fontSize: 18.65,
    fontWeight: 'bold'
  },
  description: {
    fontFamily: Fonts.mainFont,
    fontSize: 10.17,
    fontWeight: 'normal'
  }

});